<article>
  <div class="login-wrapper">
    <div class="login-container">
      <div>
        <div class="logo">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 803 668" style="enable-background: new 0 0 803 668" xml:space="preserve">
            <style type="text/css">
              .st0 {
                fill: none;
              }

              .st1 {
                fill: #f0f0f0;
                animation: col 1s ease-in;
                animation-fill-mode: forwards;
                animation-delay: 0.5s;
              }

              @keyframes col {
                0% {
                  fill: #f0f0f0;
                }

                100% {
                  fill: #00adee;
                }
              }
            </style>

            <path d="M535.9,350.4c-20.6,11.8-44.8,18.6-70.9,18.6h-44.1V235.4l-0.5-0.5l0.5-0.5V100.7H465c26.1,0,50.3,6.8,71,18.6l52-52  C553.6,42.9,510.6,29,465,29H344.5v411.7H465c45.3,0,88-14.2,122.7-38.5L535.9,350.4L535.9,350.4z" />
            <path class="st0" d="M563.3,140.1l-38.3,38.3c31.2,31.2,31.2,81.9,0,113.1l38.3,38.3C615.7,277.3,615.7,192.4,563.3,140.1  L563.3,140.1z" />
            <path class="st0" d="M647.3,56.1l-33.3,33.3c80.4,80.4,80.4,210.7,0,291.1l33.3,33.3C746.1,314.9,746.1,154.8,647.3,56.1L647.3,56.1  z" />
            <path class="st1" d="M614.1,89.3L563.4,140c52.4,52.4,52.4,137.3,0,189.6l50.7,50.7C694.5,300,694.5,169.7,614.1,89.3L614.1,89.3z   M525.1,178.3l-56.5,56.5l56.5,56.5C556.3,260.2,556.3,209.6,525.1,178.3L525.1,178.3z" />
            <path class="st1" d="M698.6,4.8l-51.2,51.2c98.8,98.8,98.8,258.9,0,357.6l51.2,51.2C825.6,337.9,825.6,131.9,698.6,4.8L698.6,4.8z" />
            <path
              d="M144.5,583.8V629h-22.3v-45.2c0-13.8-5.2-20.3-16.3-20.3c-11,0-16.3,6.5-16.3,20.3V629H67.2v-45.2  c0-13.8-5.2-20.3-16.3-20.3c-11,0-16.3,6.5-16.3,20.3V629H12.2v-45.2c0-28.9,16.7-42.1,38.7-42.1c11,0,21.1,3.8,27.5,11.9  c6.4-8.1,16.5-11.9,27.5-11.9C127.8,541.7,144.5,554.9,144.5,583.8L144.5,583.8z M243.5,586c0,24.6-19.8,44.3-44.3,44.3  c-24.6,0-44.3-19.8-44.3-44.3c0-24.6,19.8-44.3,44.3-44.3C223.7,541.7,243.5,561.4,243.5,586z M177.2,586c0,12.7,9.5,22.5,22.2,22.5  s21.8-9.8,21.8-22.5s-9.1-22.5-21.8-22.5S177.2,573.3,177.2,586z M329.4,629h-22.3v-45.2c0-13.8-4.5-20.3-15.5-20.3  s-15.5,6.5-15.5,20.3V629h-22.3v-45.2c0-28.9,15.8-42.1,37.8-42.1c22,0,37.8,13.2,37.8,42.1L329.4,629L329.4,629z M342.3,520.5  c0-7.4,5.8-13.2,13.4-13.2c7.4,0,13.2,5.8,13.2,13.2c0,7.6-5.8,13.4-13.2,13.4C348.2,533.9,342.3,528.1,342.3,520.5z M344.6,543.1  h22.3V629h-22.3V543.1z M409.4,564.9v23.5c0,13.8,4.5,19.2,15.5,19.2v21.8c-22,0-37.8-12.2-37.8-41.1v-23.5h-12.7v-21.8H387v-22.4  l12.5-11.8h9.8v34.2h15.5v21.8H409.4L409.4,564.9z M520.4,586c0,24.6-19.8,44.3-44.3,44.3c-24.6,0-44.3-19.8-44.3-44.3  c0-24.6,19.8-44.3,44.3-44.3C500.6,541.7,520.4,561.4,520.4,586z M454.1,586c0,12.7,9.5,22.5,22.2,22.5s21.8-9.8,21.8-22.5  s-9.1-22.5-21.8-22.5S454.1,573.3,454.1,586z M530.7,583.8c0-28.4,15.8-41.1,36.8-41.1h1v21.8h-0.9c-9.8,0-14.6,5.8-14.6,19.2V629  h-22.3L530.7,583.8L530.7,583.8z M579.7,520.5c0-7.4,5.8-13.2,13.4-13.2c7.4,0,13.2,5.8,13.2,13.2c0,7.6-5.8,13.4-13.2,13.4  C585.5,533.9,579.7,528.1,579.7,520.5z M581.9,543.1h22.3V629h-22.3V543.1z M694.8,629h-22.3v-45.2c0-13.8-4.5-20.3-15.5-20.3  s-15.5,6.5-15.5,20.3V629h-22.3v-45.2c0-28.9,15.8-42.1,37.8-42.1s37.8,13.2,37.8,42.1V629z M708.9,636.7h27.2  c4.5,3.4,8.4,4.8,13.4,4.8c11.3,0,21.5-5.8,21.5-16.7v-0.2c-6.4,3.6-13.6,5.7-21.5,5.7c-24.6,0-44.3-19.8-44.3-44.3  c0-24.6,19.8-44.3,44.3-44.3s44.3,19.8,44.3,44.3v33c0,24.6-19.8,44.3-44.3,44.3C731.4,663.4,715.8,652.5,708.9,636.7L708.9,636.7z   M771.5,586c0-12.7-9.1-22.5-21.8-22.5s-22.2,9.8-22.2,22.5s9.5,22.5,22.2,22.5S771.5,598.8,771.5,586z M210.4,29L12.2,293.5v72.3  l198.2,0.1v74l76.4,0.7v-74.6h28l0.3-72.4l-28.2,0.1V29H210.4z M209.7,293.5H105l105.4-140.7L209.7,293.5L209.7,293.5z" />
          </svg>
        </div>

        <div class="input-wrapper">
          <h2 class="text-center">User Registration</h2>

          <p class="browser text-center">
            @if (connectedMessage !== '') {
              <span class="warning bg-danger">
                {{ connectedMessage }}
              </span>
            }
          </p>
          @if (connectedMessage && connectedMessage !== '') {
            <p class="text-center" title="{{ connectedStatus }}">
              {{ connectedMessage }}
            </p>
          }
          <div class="reg-form">
            <p class="what-to-do">Please create a password for your login.</p>
            @if (activating) {
              <div class="text-center">
                <h3><i class="fa fa-spinner fa-pulse"></i> Activating account</h3>
                <p>please wait....</p>
              </div>
            }
            @if (!activating) {
              <div>
                <label>New Password</label>
                <div class="mb-1">
                  <input class="fourd" id="password1" name="password1" [(ngModel)]="password1" type="password" />
                </div>
                <label>Confirm Password</label>
                <div class="mb-1">
                  <input class="fourd" id="password2" name="password2" [(ngModel)]="password2" type="password" />
                </div>
                <button [disabled]="!password1 || !password2 || password1 !== password2 || password1.length < 6" (click)="activate()" class="btn btn-primary btn-block">Activate</button>
              </div>
            }
            @if (!activating) {
              <div class="hint" style="visibility: hidden">
                @if (password1 && password2 && password1 !== password2) {
                  <p>Passwords do not match.</p>
                }
                @if (password1 && !password2 && password1.length >= 6) {
                  <p>When ready, confirm password.</p>
                }
                @if (password1 && password1.length < 6) {
                  <p>Passwords must be at least 6 characters.</p>
                }
                @if (password1 && password1 === password2 && password1.length >= 6) {
                  <div class="you-can-activate">
                    <div>
                      <i class="fa fa-check-circle"></i>
                    </div>
                    <div>Thankyou, you may activate your account.</div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</article>
